import routes from '@/services/API/api'
import axios from 'axios'


/**
 * @description
 * Send request for reset user password
 * 
 * @param {oject} params
 * @return {Promise} success or error response
 */
const getLoginTokenRequest = async function(params) {
    return new Promise((resolve, reject) => {
        axios({
            url: routes.GET_LOGIN_WORKSTATION_USER_TOKEN,
            params: {
                url_token: params.login_token,
            },
            method: 'GET',
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
} // end function

export {
    getLoginTokenRequest
}